<template>
  <v-form ref="form" v-model="isValid" class="container">
    <!-- Employed Occupation Form (Displayed if isEmployed is true) -->

    <!-- Add Another Job Button -->

    <v-alert
      v-model="alert"
      border="start"
      close-label="Future Plans for KSHS"
      color="red accent-4"
      title="Are you currently employed?"
      variant="tonal"
    >
    </v-alert>
    <v-radio-group v-model="isEmployed" class="custom-switch" mandatory>
      <v-radio label="Yes" :value="true" :color="isEmployed === true ? 'success' : ''"></v-radio>
      <v-radio label="No" :value="false" :color="isEmployed === false ? 'error' : ''"></v-radio>
    </v-radio-group>
    <div v-if="isEmployed">
      <v-row v-for="(job, index) in employedOccupation" :key="index" class="mb-6">
        <!-- Employer Name and Job Title in the same row -->
        <v-col cols="12" sm="6">  
          <v-select
            label="Nature of employment"
            v-model="job.natureOfEmployment"
            :items="['Permanent', 'Contract']"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-briefcase</v-icon>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
            label="Employer type"
            v-model="job.employerType"
            :items="['Government', 'Private', 'NGO']"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-phone</v-icon>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Employer institution’s name"
            v-model="job.employerName"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-briefcase</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Job Title"
            v-model="job.jobTitle"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-account-cog</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <!-- Job Address and Job Phone Number in the same row -->
        <v-col cols="12" sm="6">
          <v-text-field
            label="Place of Work"
            v-model="job.placeOfWork"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-map-marker</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </div>

    <!-- Self-Employed Occupation Form (Displayed if isSelfEmployed is true) -->

    <!-- Add Another Business Button -->

    <v-alert
      v-model="alert"
      border="start"
      close-label="Future Plans for KSHS"
      color="red accent-4"
      title="Are you self-employed?"
      variant="tonal"
    ></v-alert>
    <v-radio-group v-model="isSelfEmployed" class="custom-switch" mandatory>
      <v-radio label="Yes" :value="true" :color="isSelfEmployed === true ? 'success' : ''"></v-radio>
      <v-radio label="No" :value="false" :color="isSelfEmployed === false ? 'error' : ''"></v-radio>
    </v-radio-group>
    <div v-if="isSelfEmployed">
      <v-row v-for="(business, index) in selfEmployedOccupation" :key="index" class="mb-6">
        <!-- Business Type and Business Name in the same row -->
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Type"
            v-model="business.businessType"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-briefcase</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Name"
            v-model="business.businessName"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-store</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <!-- Role in Business and Business Address in the same row -->
        <v-col cols="12" sm="6">
          <v-text-field
            label="Role in Business"
            v-model="business.roleInBusiness"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-account-cog</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Address"
            v-model="business.businessAddress"
            :rules="[rules.required]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-map-marker</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <!-- Business Phone Number in the same row -->
        <v-col cols="12" sm="6">
          <v-text-field
            label="Business Phone Number"
            v-model="business.businessPhoneNumber"
            :rules="[rules.required, rules.phone]"
            variant="outlined"
            dense
            class="form-field"
            color="blue"
            hide-details="auto"
          >
            <template v-slot:prepend>
              <v-icon color="red">mdi-phone</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </div>

    <!-- Submit Button -->

    <!-- Snackbar for validation messages -->
    <v-snackbar v-model="snackbar" :timeout="3000" top>
      {{ snackbarMessage }}
    </v-snackbar>
  </v-form>
</template>

<script>
export default {
  props: {
    employedOccupation: {
      type: Array,
      required: true,
    },
    selfEmployedOccupation: {
      type: Array,
      required: true,
    },
  },
  name: "EmployeeForm",
  data() {
    return {
      isEmployed: false,
      isSelfEmployed: false,
      isValid: false,
      employedOccupation: [
        {
          natureOfEmployment: "",
          employerName: "",
          jobTitle: "",
          placeOfWork: "",
          employerType: "",
        },
      ],
      selfEmployedOccupation: [
        {
          businessType: "",
          businessName: "",
          roleInBusiness: "",
          businessAddress: "",
          businessPhoneNumber: "",
        },
      ],
      rules: {
        required: value => !!value || "This field is required.",
        phone: value => /^\d+$/.test(value) || "Must be a valid phone number.",
      },
      snackbar: false,
      snackbarMessage: "",
    };
  },
  mounted() {
    // Initialize values
    this.employedOccupation = this.userEmployedOccupation;
    this.selfEmployedOccupation = this.userSelfEmployedOccupation;

    // Ensure it's a string before using trim()
    this.isEmployed = !!(this.userEmployedOccupation && String(this.userEmployedOccupation).trim());
    this.isSelfEmployed = !!(this.userSelfEmployedOccupation && String(this.userSelfEmployedOccupation).trim());

    console.log("Employed Occupation:", this.employedOccupation, "isEmployed:", this.isEmployed);
    console.log("Self Employed Occupation:", this.selfEmployedOccupation, "isSelfEmployed:", this.isSelfEmployed);
  },
  computed: {
    userEmployedOccupation() {
      return this.$store.getters["user/employedOccupation"] || null;
    },
    userSelfEmployedOccupation() {
      return this.$store.getters["user/selfEmployedOccupation"] || null;
    },
    combinedOccupation() {
      return {
        employed: this.employedOccupation,
        selfEmployed: this.selfEmployedOccupation,
      };
    },
  },
  watch: {
    "isEmployed"(newVal) {
      // this.$nextTick(() => {
        if (!newVal) {
          this.employedOccupation = [
            {
              natureOfEmployment: "",
              employerName: "",
              jobTitle: "",
              placeOfWork: "",
              employerType: "",
            },
          ];
        }
      // });
    },
    "isSelfEmployed"(newVal) {
      // this.$nextTick(() => {
        if (!newVal) {
          this.selfEmployedOccupation = [
            {
              businessType: "",
              businessName: "",
              roleInBusiness: "",
              businessAddress: "",
              businessPhoneNumber: "",
            },
          ];
        }
      // });
    },
    employedOccupation: {
      handler() {
        this.emitUpdatedData();
      },
      deep: true,
    },
    selfEmployedOccupation: {
      handler() {
        this.emitUpdatedData();
      },
      deep: true,
    },
  },
  methods: {
    reset() {
      this.isEmployed = false;
      this.isSelfEmployed = false;
      this.employedOccupation = [
        {
          natureOfEmployment: "",
          employerName: "",
          jobTitle: "",
          placeOfWork: "",
          employerType: "",
        },
      ];
      this.selfEmployedOccupation = [
        {
          businessType: "",
          businessName: "",
          roleInBusiness: "",
          businessAddress: "",
          businessPhoneNumber: "",
        },
      ];
    },
    addJob() {
      this.employedOccupation.push({
        natureOfEmployment: "",
        employerName: "",
        jobTitle: "",
        placeOfWork: "",
        employerType: "",
      });
    },
    addBusiness() {
      this.selfEmployedOccupation.push({
        businessType: "",
        businessName: "",
        roleInBusiness: "",
        businessAddress: "",
        businessPhoneNumber: "",
      });
    },
    emitUpdatedData() {
      this.$emit("update-form-data", this.combinedOccupation);
    },
    async validateForm() {
      const isValid = await this.$refs.form.validate();
      console.log('Form validation:', isValid);
      this.formIsValid = isValid.valid;
      console.log(isValid.valid ? 'All fields are valid.' : 'Validation failed.');
      if(this.isEmployed === false && this.isSelfEmployed === false)
        return true;
      return isValid.valid;   
    },
  },
};
</script>


<style scoped>
.custom-switch {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.container {
max-width: 1000px;
margin: 10px auto;
padding: 10px;
background: linear-gradient(135deg, #f0f4f8, #d9e2ec);
border-radius: 16px;
box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
border: 1px solid #e1e7ef;
transition: transform 0.3s ease, box-shadow 0.3s ease;
overflow: hidden;
position: relative;
}

.container::before {
content: '';
position: absolute;
top: -50%;
left: -50%;
width: 200%;
height: 200%;
background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
animation: rotate-bg 8s linear infinite;
z-index: 0;
}

.container:hover {
transform: translateY(-10px);
box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.container > * {
position: relative;
z-index: 1;
}

@keyframes rotate-bg {
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
}
.stylish-field {
background-color: #f9f9f9;
padding: 1px;
transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stylish-field:hover {
transform: scale(1.02);
box-shadow: 0 6px 15px rgba(54, 202, 222, 0.4);
}
.form-field {
/* margin-bottom: 20px; */
background-color: #fff;
border-radius: 10px;
box-shadow: 0 4px 12px rgba(231, 183, 179, 0.778);
transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.form-field:hover {
transform: scale(1.02);
box-shadow: 0 6px 15px rgba(109, 191, 46, 0.77);
}

.v-text-field input {
font-size: 1rem;
font-weight: 500;
}

.v-select .v-select__selections {
font-size: 1rem;
font-weight: 500;
}

.v-form .v-input__control {
border-radius: 8px;
}

.v-text-field.v-text-field--outlined {
background-color: #ffffff;
border-radius: 12px;
}

.v-text-field .v-input__append-inner {
padding-right: 5px;
}

.v-text-field .v-input__prepend-inner {
padding-left: 5px;
}

.v-select {
/* margin-top: 15px; */
}

.v-select .v-select__selections {
font-size: 1rem;
font-weight: 500;
}

.v-btn {
background-color: #6200ea;
color: white;
padding: 12px 20px;
border-radius: 50px;
box-shadow: 0 4px 10px rgb(242, 12, 12);
transition: background-color 0.3s ease;
}

.v-btn:hover {
background-color: #3700b3;
} 

.red-icon {
color: red !important;
}
</style>
